import { Box, SxProps, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { UtilisateurApiObject } from '@europrocurement/l2d-domain';
import { UtilisateursJsonldUserworkgroupRead } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { CustomAvatar } from '../../molecules';

export type UtilisateurChoiceItemProps = {
    user: UtilisateurApiObject | UtilisateursJsonldUserworkgroupRead;
    setSelectedUser?:
        | React.Dispatch<
              React.SetStateAction<
                  UtilisateurApiObject | UtilisateursJsonldUserworkgroupRead | null
              >
          >
        | undefined;
    selectedUser?: UtilisateurApiObject | UtilisateursJsonldUserworkgroupRead | null;
    sx?: SxProps;
    userInfo?: string | null;
};

export const UtilisateurChoiceItem: React.FunctionComponent<UtilisateurChoiceItemProps> =
    function ({ user, setSelectedUser, selectedUser, sx, userInfo }) {
        const { palette } = useTheme();
        const [selected, setSelected] = useState<boolean>(false);

        const handleClick = () => {
            if (setSelectedUser) {
                if (selectedUser === user) {
                    setSelectedUser(null);
                } else {
                    setSelectedUser(user);
                }
            }
        };

        useEffect(() => {
            if (selectedUser?.id === user.id) {
                setSelected(true);
            } else {
                setSelected(false);
            }
        }, [selectedUser, user]);

        return (
            <Box
                data-testid="user-choice-item"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="start"
                onClick={() => handleClick()}
                sx={{
                    margin: '0px',
                    marginBottom: '8px',
                    padding: '8px',
                    backgroundColor: selected ? palette.primary.light : palette.background.default,
                    borderRadius: '8px',
                    ...sx,
                }}
            >
                {/* Base container */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        width: '100%',
                        transition: 'all ease-in-out 300ms',
                    }}
                >
                    {selected && (
                        <FaOptionIcon
                            icon={['fas', 'check']}
                            sx={{ color: palette.primary.main }}
                        />
                    )}

                    {/* Avatar container */}
                    <Box
                        sx={{
                            marginRight: '20px',
                        }}
                    >
                        <CustomAvatar
                            firstName={user.prenom}
                            lastName={user.nom}
                            sx={{
                                width: 35,
                                height: 35,
                                borderRadius: '6px',
                                fontSize: '15px',
                            }}
                        />
                    </Box>

                    {/* Name + Mail container */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Typography
                            variant="l2dh7"
                            sx={{ lineHeight: '1.4' }}
                        >
                            {user.prenom} {user.nom}
                        </Typography>

                        {userInfo && (
                            <Typography
                                variant="l2dbodyxs"
                                color="text.gris50"
                            >
                                {userInfo}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        );
    };
